import { T } from '@homeschooling/sdk'

import * as React from 'react'

import Persistance from "./Persistence";

import defaultAva from '../Components/brand/default_ava.svg'

export interface Props {
    children?: React.ReactNode
    student: T.Student
}
  
export interface State {
}

Persistance.setValues()

export class MenuStudent extends React.Component<Props, any> {

  public render(): React.ReactNode {
    
    const student: T.Student = this.props.student
    const ava = false ? 'img' :  defaultAva

    return (
    <button id={`student-menu-${student.id}`} className="flex items-center w-full px-5 py-2 text-gray-300 transition-colors duration-200 dark:hover:bg-gray-800">
        <img className="object-cover w-8 h-8 rounded-full" src={ava} alt="" />
    
        <div className="text-left pl-2 rtl:text-right">
            <h1 className="text-sm font-medium capitalize ">{student.name}</h1>
        </div>
    </button>
    )
  }  
  
}

export default  MenuStudent